import axios from 'axios';
import { downloadFile } from 'services/download-file.service';

const API_URL = '/api/v1/billing-report/';
const RECIPIENT_LIST = 'recipient-list';
const UPLOAD_RECIPIENT_LIST = 'upload-recipient-list';
const DOWNLOAD_REPORT = 'download-report';

const getRecipientList = () => axios.get(`${API_URL}${RECIPIENT_LIST}`);

const uploadRecipientList = (file) => {
	const formData = new FormData();
	formData.append('csv', file);
	return axios.post(
		`${API_URL}${UPLOAD_RECIPIENT_LIST}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		},
	);
};

const downloadReports = async (requestData, date) => {
	const response = await axios.post(
		`${API_URL}${DOWNLOAD_REPORT}`,
		requestData,
		{
			responseType: 'blob',
		},
	);

	downloadFile(response, 'pdf', `Billing report for ${date.format('MMMM')}, ${date.format('YYYY')}`)
}

export {
	getRecipientList,
	uploadRecipientList,
	downloadReports,
};
